class DropdownMenus {
  static statusMenu = [
    { value: 1, label: "Active" },
    { value: 0, label: "Passive" },
    { value: -1, label: "Deleted" },
  ];

  static trueFalseMenu = [
    { value: true, label: "Evet" },
    { value: false, label: "Hayır" },
  ];

  static discountTypeMenu = [
    { value: "PERCENTAGE", label: "Percentage" },
    { value: "FIXED_AMOUNT", label: "Fixed Amount" },
  ];

  static addressTypeMenu = [
    { value: 0, label: "Corporate" },
    { value: 1, label: "Individual" },
  ];

  static filterFieldMenu = [
    { value: "name", label: "Name" },
    { value: "age", label: "Age" },
    { value: "date", label: "Date" },
    // Add other filter fields here
  ];
  static operationMenu = [
    { value: "equals", label: "Equals" },
    { value: "not_equals", label: "Not Equals" },
    { value: "greater_than", label: "Greater Than" },
    { value: "less_than", label: "Less Than" },
    // Add other operations here
  ];
}

export default DropdownMenus;
